<div>
  <nz-page-header class="bg-slate-100" nzBackIcon [nzGhost]="false">
    <nz-page-header-title class="max-[563px]:w-64 text-primary flex items-center gap-2">
      {{ 'roles.title' | transloco }}
      <nz-icon  nz-tooltip
                nzTooltipPlacement = 'right'
                [nzTooltipArrowPointAtCenter]="true"
                [nzTooltipTitle]="'nav.featureTooltips.roles' | transloco"
                [nzTooltipOverlayStyle]="{
                      'max-width': '400px',
                      'min-width': '300px',
                      'white-space': 'normal',
                      'line-height': '1.5'
                }"
                nz-icon nzType="info-circle" nzTheme="outline">
      </nz-icon>
    </nz-page-header-title>
    <nz-page-header-extra class="w-72 grid min-[564px]:justify-items-end">
      <nz-space>
        <button
          *appHasAnyPrivilege="'ROLE.ADD'"
          nz-button
          nzType="primary"
          [routerLink]="'/admin/roles/add'" class="flex items-center justify-center gap-2">
          <lucide-icon name="user" class="icon-size"></lucide-icon>
          {{ 'roles.addRoleBtn' | transloco }}
        </button>
      </nz-space>
    </nz-page-header-extra>
  </nz-page-header>
</div>
<div class="my-8">
  <nz-table
    #roleTable
    [nzData]="allRoles"
    nzBordered
    [nzScroll]="{ x: '600px' }">
    <thead>
      <tr>
        <th>{{ 'roles.table.roleName' | transloco }}</th>
        <th>{{ 'roles.table.permissions' | transloco }}</th>
        <th *appHasAnyPrivilege="'ROLE.EDIT'">{{ 'roles.table.action' | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let role of roleTable.data">
        <td>{{ role.name }}</td>
        <td>
          <nz-tag [nzColor]="'geekblue'">{{ role.permissions?.length }}</nz-tag>
          <span class="text-sm">{{ 'roles.permissionsAssigned' | transloco }}</span>
        </td>
        <td>
          <button
            *appHasAnyPrivilege="'ROLE.EDIT'"
            nz-button
            nzType="default"
            nzSize="small"
            routerLink="/admin/roles/edit/{{ role._id }}" class="flex items-center justify-center gap-2">
            <lucide-icon name="pencil" class="icon-size"></lucide-icon>
            {{ 'roles.editBtn' | transloco }}
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
